import { registerMutation } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { RouteOptimizationResult } from '@nsc/route-optimization/entities/RouteOptimizationResult.js';
import { assertNexusSchedulingMutationAllowed } from './assert-nexus-scheduling-access.js';
import { runRoutePlanning } from '../server/index.js';

export const runFullSimulatedScheduling = registerMutation({
  operationName: 'runFullSimulatedScheduling',
  type: () => RouteOptimizationResult,
  resolve: () => async (gqlFields: BaseQLSelectionSet<RouteOptimizationResult>) => {
    await assertNexusSchedulingMutationAllowed();
    return await runRoutePlanning('manual-dry-run');
  },
  params: [],
});
